<template>
  <component :is="element" class="ru:decorated-text">
    <slot />
  </component>
</template>

<script>
export default {
  name: 'ComponentsAtomsDecoratedText',
  props: {
    decoration: {
      default: 'underline',
      type: String,
    },
  },
  computed: {
    element() {
      if (this.decoration === 'circle') {
        return 'mark';
      }
      return 'u';
    },
  },
};
</script>

<style lang="scss">
#{$ru} {
  &decorated-text {
    display: inline-block;
    position: relative;
    background-color: transparent;
    text-decoration: none;

    &:not(:only-child) {
      white-space: nowrap;
    }

    &::before {
      background-size: 100% 100%;
      background-position: center center;
      display: block;
      content: '';
      position: absolute;
      z-index: -1;
    }

    &:is(mark) {
      color: inherit;

      &::before {
        @include background-svg(
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 187 111" preserveAspectRatio="none"><path fill="#d2f9e2" d="M34.761 16.436c-3.535 1.647-6.932 3.62-10.295 5.748-3.206 2.03-6.427 4.094-9.376 6.682-3.093 2.75-6.056 5.892-8.352 9.83C3.774 43.781 1.34 49.855.955 56.906c-.42 7.61.985 15.891 5.248 22.187 1.72 2.541 3.82 4.675 5.762 6.908.772.869 1.5 1.844 2.345 2.535 1.006.817 2.042 1.563 3.042 2.35 1.888 1.466 3.782 2.965 5.706 4.392 2.085 1.554 4.31 2.72 6.5 3.83 3.652 1.86 7.386 3.378 11.124 4.506 2.16.663 4.295 1.007 6.44 1.607 2.147.601 4.277 1.335 6.424 1.838a78.777 78.777 0 0 0 14.3 2.03 99.112 99.112 0 0 0-1.469-.165c13.26 1.673 26.433 2.232 39.505 1.613 12.54-.6 25.08-1.913 37.261-4.67 7.272-1.653 14.368-4.013 21.204-7.256-.471.2-.921.396-1.392.596 1.982-.66 3.931-1.475 5.755-2.553 1.53-.886 2.873-2.119 4.313-3.211 2.966-2.203 5.813-4.543 8.007-8.133.941-1.534 1.882-3.068 2.506-4.922.486-1.467.802-2.995 1.153-4.562.27-1.226.568-2.425.816-3.646.503-2.41.743-4.796.482-7.43-.109-1.11-.274-2.176-.418-3.246-.49-3.166-.741-6.773-1.823-9.778-.895-2.462-2.018-4.939-3.28-7.126-2.138-3.746-4.864-7.104-7.844-9.37-1.5-1.13-2.812-2.627-4.254-3.9-1.801-1.583-3.662-2.927-5.551-4.2-1.551-1.054-3.148-1.905-4.737-2.724-1.667-.868-3.308-2.13-4.959-3.13A91.885 91.885 0 0 0 143 15.937c-7.231-3.283-14.493-5.067-21.804-6.97-3.846-1.008-7.714-2.01-11.56-3.017-3.826-1.012-7.722-1.328-11.524-1.924-7.978-1.271-15.934-2.645-23.877-3.34-7.509-.661-14.94-.659-22.38-.59-7.44.07-14.902.338-22.17 1.602-7.183 1.244-14.629 3.13-21.033 7.12-1.601.869-3.035 1.992-4.392 3.26-1.486 1.395-2.47 3.036-3.081 5.47-.617 2.403-.812 5.816-.26 8.548.437 2.205 1.181 4.894 2.729 6.241 1.33 1.168 3.029 1.672 4.242.565 2.714-2.538 5.747-4.334 8.945-5.68-.471.2-.92.395-1.392.595 7.894-3.215 16.301-4.694 24.763-5.31a235.737 235.737 0 0 1 25.944-.417c4.964.18 9.933.585 14.928 1.212-.483-.056-.965-.113-1.47-.165 5.591.691 11.186 1.705 16.795 2.587 2.809.456 5.617.912 8.419 1.337 2.808.456 5.633 1.298 8.438 2.046 10.569 2.78 21.122 5.077 31.506 10.392 2.748 1.41 5.437 2.961 8.111 4.646 1.404.892 2.758 1.763 4.171 2.492a41.164 41.164 0 0 1 3.972 2.405c-.472-.318-.923-.64-1.396-.959 2.46 1.732 4.638 3.913 6.959 6.032.984.919 2.092 1.584 3.083 2.534 1.013.946 1.945 2.039 2.827 3.207-.385-.532-.791-1.059-1.175-1.59 1.343 1.845 2.506 3.892 3.511 6.136-.312-.71-.623-1.42-.914-2.134.132.295.264.59.367.86.145.357.563 1.756.176.188-.394-1.6-.105-.172-.045.204.065.505.158 1.035.224 1.54.292 1.848.562 3.7.86 5.58.096-2.84.171-5.676.26-8.548-.292 1.328-.591 2.625-.883 3.952-.171.75-.365 1.506-.494 2.247-.261 1.062-.144.777.329-.85-.304.553-.268.513.095-.182.775-1.369-.188.268-.354.53-.268.416-.542.8-.816 1.184a22.79 22.79 0 0 1-1.93 2.236c.424-.417.827-.829 1.25-1.245-1.508 1.496-3.219 2.582-4.839 3.876-1.728 1.414-3.595 2.503-5.537 3.348.471-.2.921-.395 1.392-.596a583.327 583.327 0 0 0-6.803 2.88c.471-.2.921-.396 1.392-.596-11.128 4.602-22.91 6.721-34.777 8.146-11.86 1.456-23.846 2.13-35.963 1.794a210.28 210.28 0 0 1-20.373-1.546c.482.057.965.113 1.469.165-2.3-.275-4.586-.392-6.863-.672.483.056.965.113 1.469.165a76.251 76.251 0 0 1-9.535-1.839c-1.523-.412-3.038-.892-4.575-1.367-1.536-.474-3.104-.683-4.655-1.122-6.106-1.615-12.15-4.281-18.021-7.795.472.318.923.64 1.395.959-2.775-2.149-5.543-4.266-8.34-6.41-1.345-1.035-2.48-2.44-3.679-3.831-1.227-1.417-2.476-2.83-3.71-4.278.385.532.791 1.059 1.176 1.59a28.737 28.737 0 0 1-2.16-3.838c.312.71.624 1.42.914 2.134-.276-.653-.482-1.288-.716-1.95-.62-1.712.38 2.25.143.552-.39-2.702-.01 2.109-.004.292-.01-.354-.013-.677-.017-1-.014.65-.036 1.271-.05 1.922.011-.358.05-.691.09-1.024.14-1.1.072-.696-.227 1.216.126-.448.21-.985.314-1.43.216-.857 1.053-2.66-.144.162.19-.463.345-.983.557-1.45.19-.463.401-.93.612-1.398.139-.29 1.053-1.948.256-.574-.797 1.373.166-.264.332-.527.268-.415.52-.794.788-1.209a38.422 38.422 0 0 1 3.796-4.556c-.424.417-.826.829-1.25 1.246 3.14-3.15 6.648-5.536 10.205-7.803 3.693-2.362 7.44-4.574 11.319-6.394 1.464-.676 2.613-3.617 3.081-5.469.617-2.403.812-5.816.26-8.547-.437-2.206-1.18-4.895-2.729-6.242-1.47-1.3-2.728-1.22-4.186-.512Z" opacity=".75"/></svg>'
        );
        inset: -0.25em;
      }
    }

    &:is(u) {
      color: inherit;

      &::before {
        @include background-svg(
          '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 193 19" preserveAspectRatio="none"><path stroke="#d2f9e2" stroke-width="10" d="M1.55 10.964c2.96-.493 5.888-1.28 8.882-1.479C60.01 6.2 138.785 1.52 186.847 5.137c12.497.941-24.943 2.579-37.364 4.28-12.08 1.652-24.081 3.852-36.121 5.778"/></svg>'
        );
        height: 1rem;
        inset: 90% -0.25rem auto;
      }
    }
  }
}
</style>
